import React from 'react';
import { Phone, ExternalLink, HeartHandshake } from 'lucide-react';
import { SUPPORT_RESOURCES, EMERGENCY } from '../data/resources';

// A tel: link works as-is on a phone. Dashes are cosmetic for reading;
// stripped here only for the href so dialing isn't affected by formatting.
const telHref = (phone) => `tel:${phone.replace(/[^0-9+*]/g, '')}`;

/**
 * @param {{ compact?: boolean }} props - compact renders a shorter version
 * for use inside another card (e.g. the hard-day modal) instead of a full section.
 */
const SupportResources = ({ compact = false }) => {
  if (compact) {
    return (
      <div className="bg-white bg-opacity-60 rounded-xl p-3 text-center">
        <p className="text-xs text-stone-600 mb-2">
          אם אתה צריך לדבר עם מישהו עכשיו - זה לא רק אפליקציה שיכולה לעזור
        </p>
        <a
          href={telHref(SUPPORT_RESOURCES[0].phone)}
          className="inline-flex items-center gap-2 bg-bloom-500 text-white px-4 py-2 rounded-lg font-bold text-sm"
        >
          <Phone className="w-4 h-4" /> ער"ן: {SUPPORT_RESOURCES[0].phone}
        </a>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl p-4 border border-stone-200 shadow-sm">
      <div className="flex items-center gap-2 mb-1">
        <HeartHandshake className="w-5 h-5 text-bloom-500" />
        <h3 className="font-bold text-stone-800">עזרה אנושית</h3>
      </div>
      <p className="text-xs text-stone-500 mb-4">
        האפליקציה עוזרת לעקוב ולתעד - היא לא תחליף לטיפול מקצועי או לתמיכה אנושית.
        אלה גורמים אמיתיים בישראל שאפשר לפנות אליהם.
      </p>

      <div className="space-y-2">
        {SUPPORT_RESOURCES.map(r => (
          <div key={r.id} className="bg-stone-50 rounded-lg p-3">
            <div className="flex items-start justify-between gap-2">
              <div>
                <p className="font-semibold text-stone-800 text-sm">{r.name}</p>
                <p className="text-xs text-stone-500 mt-0.5">{r.desc}</p>
                <p className="text-xs text-stone-400 mt-0.5">{r.hours}</p>
              </div>
              <div className="flex flex-col items-end gap-1 shrink-0">
                {r.phone && (
                  <a
                    href={telHref(r.phone)}
                    className="inline-flex items-center gap-1 bg-brand-500 text-white px-2.5 py-1 rounded-md text-xs font-bold whitespace-nowrap"
                  >
                    <Phone className="w-3 h-3" /> {r.phone}
                  </a>
                )}
                <a
                  href={r.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-1 text-brand-600 text-xs"
                >
                  אתר <ExternalLink className="w-3 h-3" />
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-3 pt-3 border-t border-stone-100">
        <p className="text-xs text-stone-500">
          <span className="font-semibold text-red-600">מצב חירום רפואי</span> (כמו רעד קשה,
          בלבול או פרכוסים בגמילה מאלכוהול או מכדורי הרגעה) - זו לא שעת טיפול עצמי.
          {' '}
          <a href={telHref(EMERGENCY.phone)} className="font-bold text-red-600">
            {EMERGENCY.name}: {EMERGENCY.phone}
          </a>
        </p>
      </div>
    </div>
  );
};

export default SupportResources;
